import request from '@/request'

export async function getComingSoonCourses (params = null) {
  const response = await request({
    url: `/courses/coming`,
    method: 'get',
    params,
  })

  return response.data
}

export async function getPremiumCourses() {
  const response = await request({
    url: `/courses/premium`,
    method: 'get',
  })

  return response.data
}

export async function getCourseMaterials (courseId) {
  const response = await request({
    url: `/courses/${courseId}/materials`,
    method: 'get'
  })

  return response.data.data
}

export async function getUserCoursesWithCertificateAvailable (userId = 'me') {
  const response = await request({
    url: `users/${userId}/certificates`,
    method: 'get'
  })

  return response.data.data
}

export async function getCertificate (certificateId) {
  const response = await request({
    url: `/certificate/${certificateId}/validate`,
    method: 'get'
  })

  return response.data.data
}

export async function getCourseAttendedPercent (courseId) {
  const response = await request({
    url: `/courses/${courseId}/attended-percent`,
    method: 'get'
  })

  return response.data.data
}

export async function generateCourseCertificate (courseId) {
  try {
    const response = await request({
      url: `/certificate/${courseId}/pdf`,
      method: 'get'
    })

    return response.data.data
  } catch (err) {
    return false
  }
}

export async function createCourseClassActivityPercent (courseClassId, percent = 0) {
  try {
    const response = await request({
      url: `/activity`,
      method: 'post',
      data: {
        course_class_id: courseClassId,
        video_percent: percent
      }
    })

    return response.data
  } catch (err) {
    return null
  }
}

export async function getSummaryCategorized () {
  const response = await request({
    url: '/course/summary-categorized',
    method: 'get'
  })

  return response.data.data
}

export async function getHighlight () {
  const response = await request({
    url: '/courses/highlight',
    method: 'get'
  })

  return response.data.data
}

export async function getIndex (params) {
  const response = await request({
    url: `/courses`,
    method: 'get',
    params,
  })

  return response.data.data
}

// @alias
export async function getCourse (id) {
  return await fetchCourse(id)
}

export async function fetchPublicCourses() {
  const response = await request({
    url: `/courses/public`,
    method: 'get'
  })

  return response.data.data
}

export async function fetchCourse (courseId) {
  const response = await request({
    url: `/courses/${courseId}`,
    method: 'get'
  })

  return response.data.data
}

export async function fetchCourseModules (courseId) {
  const response = await request({
    url: `/courses/${courseId}/modules`,
    method: 'get'
  })

  return response.data
}

export async function getUserCoursesOngoing (userId, params = {}) {
  const res = await request({
    url: `users/${userId}/courses/ongoing`,
    method: 'get',
    params
  })

  return res.data
}

export async function getRelatedCourses (courseId, params = {}) {
  const res = await request({
    url: `courses/${courseId}/related`,
    method: 'get',
    params
  })

  return res.data
}